import React, {FC} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {UnreachableError} from '../../../../libs/shared/helpers/src/types/customErrors';
import {BannerTypesEnum, LensesBannerState} from '../../../store/panels/app/banners/bannersState';
import {LensesErrorBanner} from './lensesErrorBanners';
import {LensesSuccessBanner} from './lensesSuccessBanner';

/*
 * Props.
 */

interface LensesBannersProps {
  banners: ReadonlyArray<LensesBannerState>;
  onClose: HandlerOf<string>;
}

/*
 * Component.
 */

export const LensesBanners: FC<LensesBannersProps> = (props) => {
  const {banners, onClose} = props;
  return (
    <>
      {banners.map((banner) => {
        switch (banner.type) {
          case BannerTypesEnum.SUCCESS:
            return (
              <LensesSuccessBanner key={banner.uid} banner={banner} onClose={() => onClose(banner.uid)} />
            );

          case BannerTypesEnum.ERROR:
            return <LensesErrorBanner key={banner.uid} banner={banner} onClose={() => onClose(banner.uid)} />;

          default:
            throw new UnreachableError(banner);
        }
      })}
    </>
  );
};
